<template>
    <div id="ai-depart-background">
        <dx-popup
            v-if="navigateDone"
            ref="appDepPopupRef"
            :show-close-button="!disabledCloseButton"
            :visible="true"
            maxWidth="1200"
            :width="'90%'"
            :height="'90%'"
            minHeight="500"
            @hiding="handleHiding"
            @hidden="closePopup"
        >
            <template #title>
                <div id="ai-depart-h" class="ai-depart-h">
                    <p>Выбор приложения и подразделения</p>
                    <ai-svg id="ai-svg-depart" />
                </div>
            </template>
            <div class="flex gap-4 h-full ai-depart-popup">
                <component :is="'AppList'" id="ai-depart-app-list-app" :app-list="appListFiltered" />
                <department-list
                    id="ai-depart-app-list-depart"
                    ref="treeViewRef"
                    @empty-filter-result="emptyFilterResult"
                    @set-depart="setDepart"
                />
            </div>

            <dx-toolbar-item location="after" toolbar="bottom">
                <dx-button
                    id="ai-app-depart-select-button"
                    :disabled="disabledButton"
                    :width="120"
                    text="Ок"
                    type="default"
                    @click="onClick($event)"
                />
            </dx-toolbar-item>
        </dx-popup>
    </div>
</template>

<script>
export default {
    name: 'app-depart-layout',
};
</script>

<script setup>
import { computed, provide, reactive, ref, onMounted } from 'vue';
import AppList from './components/app-list.vue';
import DxButton from 'devextreme-vue/button';
import { useRouter } from 'vue-router';
import { DxPopup, DxToolbarItem } from 'devextreme-vue/popup';
import { getCookie, setCookie } from '@/utils/cookies';
import { checkTokenExpired } from '@/utils/token';
import { getUserApps, getUserDeparts } from '@/store/global';
import { getApp } from '@/store/global';
import DepartmentList from '@/layouts/app-depart-layout/components/department-list.vue';
import { openedTabListSet } from '@/service/userdata-service';
import { setOpenedTabs } from '../main-layout/components/navigation-bars-data';

const router = useRouter();
const appDepPopupRef = ref(null);
const isShowDepartments = ref(true);
const isButtonDisable = ref(false);
const appListFiltered = ref([]);
const navigateDone = ref(false);
const emptyFilterResult = () => {
    isButtonDisable.value = true;
};
const setDepart = () => {
    isButtonDisable.value = false;
};
provide('isShowDepartments', isShowDepartments);
const treeViewRef = ref();

let formData = reactive({
    appId: getCookie('app'),
    depId: getCookie('dep'),
});

const idContainer = reactive({
    neededDepId: null,
});

const isOneDepartmentAvailible = async (userDeparts, idContainer, userApps) => {
    const childCount = {};

    userDeparts.items.forEach(item => {
        if (item.parent_id !== null) {
            childCount[item.parent_id] = (childCount[item.parent_id] || 0) + 1;
        }
    });

    let lowestLeaf = null;
    let lowestLeafCount = 0;

    userDeparts.items.forEach(item => {
        if (!item.parent_id) return;

        if (childCount[item.dep_id] === undefined) {
            if (lowestLeaf === null) {
                lowestLeaf = item;
                lowestLeafCount = 1;
            } else {
                lowestLeafCount++;
            }
        }
    });

    if (lowestLeafCount > 1) {
        console.log('Больше одного самого низкого листа.');
    } else if (lowestLeaf) {
        idContainer.neededDepId = lowestLeaf.dep_id;
        const appID = userApps.items.at(0).kod_app;
        const depID = idContainer.neededDepId;
        setCookie('app', appID);
        setCookie('dep', depID);
        await router.push({
            name: 'home-view',
            params: { app: appID, dep: depID },
        });
    } else {
        console.log('Не найдено ни одного листа.');
    }
};

onMounted(async () => {
    const userApps = await getUserApps();

    if (userApps.items?.length === 0) {
        throw Error('У пользователя отсутвует приложения ');
    }

    if (userApps.items && userApps.items?.length === 1) {
        const userDeparts = await getUserDeparts();
        if (userDeparts.items.length === 0) {
            throw Error('У пользователя отсутсвуют подразделения');
        }
        await isOneDepartmentAvailible(userDeparts, idContainer, userApps);
    }

    const app = getApp();
    app.component('AppList', AppList);
    const getFilteredAppResp = await getUserApps();
    if (!getFilteredAppResp.result) {
        await router.push('login');
        return;
    }
    appListFiltered.value = getFilteredAppResp.items.map(app => {
        return {
            ...app,
            svg: app.settings?.app_svg,
        };
    });
    const token = getCookie('token');
    const res = checkTokenExpired(token);
    if (!res.result) {
        router.push({
            name: 'loginForm',
        });
    }
    navigateDone.value = true;
});

const onClick = async event => {
    setCookie('app', formData.appId);
    setCookie('dep', formData.depId);
    // todo Загрузить права пользователя в window.global.rightUiChildObj
    // todo Загрузить права пользователя в window.global.rightUiRoute

    setOpenedTabs({
        focusedTab: {
            src: '/infoenergo/assets/home.svg',
            name: 'home-view',
            buttonCloseHide: true,
            viewId: 'home-view',
            routeName: 'home-view',
            userData: {
                changes: [],
                data: {},
            },
        },
        openedTabs: [
            {
                src: '/infoenergo/assets/home.svg',
                name: 'home-view',
                buttonCloseHide: true,
                viewId: 'home-view',
                routeName: 'home-view',
            },
        ],
    });

    openedTabListSet({
        focused: {
            src: '/infoenergo/assets/home.svg',
            name: 'home-view',
            buttonCloseHide: true,
            viewId: 'home-view',
            routeName: 'home-view',
            userData: {
                changes: [],
                data: {},
            },
        },
        tabs: [],
    });

    router.push({
        name: 'home-view',
        params: { app: formData.appId, dep: formData.depId },
    });
};

const handleHiding = event => {
    event.cancel = true;
};

const closePopup = event => {
    const depId = getCookie('dep');
    const appId = getCookie('app');
    router.push({
        name: 'home-view',
        params: { app: appId, dep: depId },
    });
};

const disabledButton = computed(() => {
    return isButtonDisable.value || !formData.depId || !formData.appId;
});
const disabledCloseButton = computed(() => {
    return !getCookie('dep') && !getCookie('app');
});
provide('formData', formData);
</script>
<style lang="scss" scoped>
#ai-depart-background {
    background-image: url('../../assets/login-background.jpeg');
    background-size: 3400px 2000px;
    background-position-x: -1100px;
    background-position-y: -300px;
    height: 100%;
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
}

#ai-depart-h {
    padding: 35px 30px 5px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    font-size: 34px;
    font-weight: bold;
    border-style: none;
    background-color: #f6fafe;
}

#ai-svg-depart {
    :first-child {
        margin-left: -13px;
    }
}

#ai-app-depart-select-button {
    border-radius: 8px;
    font-size: 14px;
    text-transform: none;
}

.ai-depart-popup {
    padding-bottom: 20px;
    padding-right: 20px;
    display: flex;
}

#ai-depart-app-list-depart {
    flex-grow: 1;
}
</style>
